// URL search params owned by PRD-list tab controls. PrdTable forwards every
// other search param to /prds, so these are stripped from the request key —
// two tables on one page (home: My PRDs + Participating) must not change
// each other's keys or share one All/My Open/My Done state.

/** All/My Open/My Done tab of the main PRD table (My PRDs, /prds, app lists). */
export const PRD_STATUS_PARAM = "status";
/** Stage tab of the open work queue. */
export const PRD_STAGE_PARAM = "stage";
/** Identity tab of ParticipatingTabs. */
export const PARTICIPATING_PARAM = "participating";
/** All/My Open/My Done tab of the Participating table (separate from ?status=). */
export const PARTICIPATING_STATUS_PARAM = "pstatus";

export const PRD_LIST_UI_PARAMS = [
  PRD_STATUS_PARAM,
  PRD_STAGE_PARAM,
  PARTICIPATING_PARAM,
  PARTICIPATING_STATUS_PARAM,
];
